module.exports = __webpack_public_path__ + "static/elMirageSermons-999c3c370b511518b4ac0a83cb79cb40.jpg";